import React, { useRef, useState } from "react";
import "./contactMe.css";
import emailjs from "@emailjs/browser";
import CircularProgress from "@mui/material/CircularProgress";

export default function Contact() {
  const [contactForm, setContactForm] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [messageSent, setMessageSent] = useState(false);
  const formRef = useRef();
  const serviceId = process.env.REACT_APP_SERVICE_ID;
  const templateId = process.env.REACT_APP_TEMPLATE_ID;
  const publicKey = process.env.REACT_APP_PUBLIC_ID;

  const handleChange = (e, field) => {
    const value = e.target.value;
    setContactForm((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const templateParams = {
      name: contactForm.name,
      email: contactForm.email,
      message: contactForm.message,
    };

    try {
      await emailjs.sendForm(
        serviceId,
        templateId,
        formRef.current,
        publicKey,
        templateParams
      );
      setIsSubmitting(false);
      setMessageSent(true);
      setTimeout(() => setMessageSent(false), 5000);
      setContactForm({ name: "", email: "", message: "" }); // Reset the form
    } catch (error) {
      console.error("Error sending email:", error);
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="contactContainer">
        <div className="contactTitle">
          <h1>Contact Me</h1>
          <div>
            <hr />
          </div>
        </div>
        <div className="contactContent">
          <form ref={formRef} className="contactForm" onSubmit={handleSubmit}>
            <div className="inputGroup">
              <label htmlFor="name">Name</label>
              <input
                name="name"
                onChange={(e) => handleChange(e, "name")}
                value={contactForm.name}
                required
              />
            </div>
            <div className="inputGroup">
              <label htmlFor="email">Email</label>
              <input
                name="email"
                onChange={(e) => handleChange(e, "email")}
                value={contactForm.email}
                type="email"
                required
              />
            </div>
            <div className="inputGroup">
              <label htmlFor="message">Message</label>
              <textarea
                name="message"
                rows="8"
                onChange={(e) => handleChange(e, "message")}
                value={contactForm.message}
                required
              />
            </div>
            <div className="buttonContainer">
              {isSubmitting ? (
                <CircularProgress className="circularProgress" />
              ) : (
                <>
                  {messageSent && (
                    <span className="messageSent">Message Recieved!</span>
                  )}
                  <button className="submitButton" type="submit">
                    Submit
                  </button>
                </>
              )}
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
